import { render, staticRenderFns } from "./product-popup-edit-new-info.vue?vue&type=template&id=db0bd764"
import script from "./product-popup-edit-new-info.vue?vue&type=script&lang=js"
export * from "./product-popup-edit-new-info.vue?vue&type=script&lang=js"
import style0 from "./product-popup-edit-new-info.vue?vue&type=style&index=0&id=db0bd764&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db0bd764')) {
      api.createRecord('db0bd764', component.options)
    } else {
      api.reload('db0bd764', component.options)
    }
    module.hot.accept("./product-popup-edit-new-info.vue?vue&type=template&id=db0bd764", function () {
      api.rerender('db0bd764', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/product-management/product-management/product-popup-edit-new-info.vue"
export default component.exports